// extracted by mini-css-extract-plugin
module.exports = {"expand-button":"dd31006766--expand-button--OveCW","arrow":"dd31006766--arrow--_DI1e","rotated":"dd31006766--rotated--tWa1K"};